// noinspection JSUnresolvedVariable

import {createReplaceableElement} from "../helpers/replaceableElement";
import {setAsDateField, setAsSelect2} from "../helpers/inputs";
import {hideLoading, showLoading} from "../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../helpers/handleAjaxError";
import createElement from "../helpers/createElement";
import {getSingleInputByNameV3} from "../helpers/inputs/forms/fornInputHelpers";
import {getInputsByName} from "../helpers/forms";

function initCustomerChangeOrdersIndex() {
	// Init card components
	const cardComponentInstance = createReplaceableElement({
		element: document.querySelector('.change-orders-card'),
		init() {

			// Setup budget/category/item filters
			// Init budget item select element
			// noinspection DuplicatedCode
			this.budgetSelectElement = this.element.querySelector('select[name="component_budget_id"]');
			if (this.budgetSelectElement) {
				setAsSelect2(this.budgetSelectElement);

				$(this.budgetSelectElement).on('change', refreshCard);
			}

			// Init category select element
			this.categorySelectElement = this.element.querySelector('select[name="component_budget_category_id"]');
			if (this.categorySelectElement) {
				setAsSelect2(this.categorySelectElement);

				$(this.categorySelectElement).on('change', refreshCard);
			}


			// Init budget item select element
			this.budgetItemSelectElement = this.element.querySelector('select[name="component_budget_item_id"]');
			if (this.budgetItemSelectElement) {
				setAsSelect2(this.budgetItemSelectElement);

				$(this.budgetItemSelectElement).on('change', refreshCard);
			}

			// Setup dates filters
			this.element.querySelectorAll('.date-only-input').forEach(input => {
				setAsDateField(input, {
					showClear: true,
				});

				$(input).on('dp.hide', () => refreshCard(cardComponentInstance))
			})
		},
		getCategoryFilter() {
			return this.element.querySelector('select[name="category_filter"]');
		},
	})

	// Make card visible
	cardComponentInstance.element.classList.remove('opacity-0')


	// Methods

	function refreshCard() {
		const refreshRoute = getSingleInputByNameV3(cardComponentInstance.element, 'refreshRoute');

		showLoading(cardComponentInstance.element);

		const data = {};

		// Pass available filters
		if (cardComponentInstance.budgetSelectElement) {
			data.budget_id = cardComponentInstance.budgetSelectElement.value;
		}
		if (cardComponentInstance.categorySelectElement) {
			data.category_id = cardComponentInstance.categorySelectElement.value;
		}
		if (cardComponentInstance.budgetItemSelectElement) {
			data.budget_item_id = cardComponentInstance.budgetItemSelectElement.value;
		}

		const dateFilters = getInputsByName(cardComponentInstance.element, ['from', 'to']);

		data.from = dateFilters.from ? dateFilters.from : undefined;
		data.to = dateFilters.to ? dateFilters.to : undefined;

		Axios.post(refreshRoute, data)
			.then(response => {
				// Update HTML
				cardComponentInstance.replace(createElement(response.data.html));
			})
			.catch(handleAjaxError)
			.finally(() => {
				hideLoading(cardComponentInstance.element)
			})
	}
}

export {initCustomerChangeOrdersIndex}
